export interface IEdgeTrace {
  country: string;
  colo: string;
}

let cached: IEdgeTrace | null = null;

export async function getEdgeTrace(): Promise<IEdgeTrace> {
  if (cached) {
    return cached;
  }
  if (typeof window === 'undefined') {
    return { country: '', colo: '' };
  }
  try {
    const res = await fetch('/cdn-cgi/trace', { cache: 'no-store' });
    const text = await res.text();
    const country = text.match(/^loc=([A-Z]{2})/m)?.[1] ?? '';
    const colo = text.match(/^colo=([A-Z]{3})/m)?.[1] ?? '';
    cached = { country, colo };
    return cached;
  } catch {
    return { country: '', colo: '' };
  }
}
